import React from "react";
import Popup from "../../popup";

const PDFPopup = ({ link, name, modalID, title }) => {
  return (
    <Popup
      needbtn={false}
      large={true}
      title={title || name}
      name={name}
      modalID={modalID}
    >
      <div style={{ height: "70vh", width: "100%" }}>
        <iframe
          src={link}
          width="100%"
          height="100%"
          style={{ border: "none" }}
          title="PDF Preview"
        />
      </div>
    </Popup>
  );
};

export default PDFPopup;
